import { render, staticRenderFns } from "./ChangeStatusModal.vue?vue&type=template&id=2a9f8e8e&"
import script from "./ChangeStatusModal.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports